import React from "react";

// App-wide safety net: if any screen throws while rendering, show a friendly
// recovery screen instead of a blank white page.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep a console trace for debugging; never surface raw errors to users.
    console.error("Unhandled UI error:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0A1628",
          padding: "24px",
        }}
        data-testid="app-error-boundary"
      >
        <div style={{ maxWidth: 440, textAlign: "center" }}>
          <div
            style={{
              width: 56,
              height: 56,
              margin: "0 auto 20px",
              borderRadius: "50%",
              border: "2px solid rgba(201,168,76,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#C9A84C",
              fontSize: 26,
              fontWeight: 700,
            }}
          >
            !
          </div>
          <h1 style={{ color: "#fff", fontSize: 22, marginBottom: 10, fontWeight: 600 }}>
            Something went wrong
          </h1>
          <p style={{ color: "#94a3b8", fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>
            We hit an unexpected error while loading this page. Please reload — if it keeps
            happening, head back to the homepage.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                background: "#C9A84C",
                color: "#0A1628",
                fontWeight: 600,
                fontSize: 14,
                border: "none",
                padding: "12px 26px",
                cursor: "pointer",
              }}
              data-testid="error-reload-btn"
            >
              Reload page
            </button>
            <button
              type="button"
              onClick={() => { window.location.href = "/"; }}
              style={{
                background: "transparent",
                color: "#e2e8f0",
                fontWeight: 500,
                fontSize: 14,
                border: "1px solid rgba(255,255,255,0.2)",
                padding: "12px 26px",
                cursor: "pointer",
              }}
              data-testid="error-home-btn"
            >
              Go to homepage
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
